import { connect }  from 'react-redux';
import Locale       from '../../../locale';
import LocaleString from './locale-string.jsx';


export default connect(
    // mapStateToProps
    state => {
        return {
            getString: ( key, replaceOptions ) => Locale.getString( state, key, replaceOptions )
        };
    },
    // mapDispatchToProps
    {}
)( LocaleString );
